// Auto-generated by splitter.py — do not regenerate; edit directly.

import { ArrowLeftRight, BadgeCheck, Banknote, BarChart3, Bell, Building2, Calendar, ClipboardList, Coins, Headset, Inbox, LayoutDashboard, MapPin, MessageCircle, Newspaper, Package, Palette, PhoneCall, Plug, Scale, ScrollText, ServerCog, Settings, ShieldAlert, ShieldCheck, Split, Store, Tag, Ticket, Trophy, Users, Wallet, Workflow, Wrench } from 'lucide-react';

export const NAV = [
  {
    section: null,
    items: [
      { id: 'dashboard', label: 'Dashboard', icon: LayoutDashboard },
    ],
  },
  {
    section: 'CORE OPERATIONS',
    items: [
      { id: 'events',           label: 'Events',                icon: Calendar },
      {
        id: 'event-requests', label: 'Event Requests', icon: ClipboardList,
        // badge: 'dot'
      },
      { id: 'organizers',       label: 'Organizers',            icon: Building2 },
      { id: 'venues',           label: 'Venues',                icon: MapPin },
      { id: 'tournaments',      label: 'Tournaments & Teams',   icon: Trophy },
    ],
  },
  {
    section: 'SALES & FINANCE',
    items: [
      {
        id: 'orders', label: 'Orders', icon: Inbox,
        // badge: 'dot'
      },
      // Splits and instalment plans are money owed TO us on an order that has not finished
      // paying — so they sit with Orders and Transactions, not under Events. The Events module
      // carries the core event record and would drown in a niche payment arrangement.
      //
      // "Payment Plans", not "Split Payments": the module holds BOTH kinds, and an operator opening
      // a page called Split Payments to find one-person instalment plans reasonably wonders whether
      // they are in the wrong place. The route stays /split-payments — a URL is an identifier, and
      // saved views are stored as URLs.
      { id: 'split-payments',   label: 'Payment Plans',         icon: Split },
      { id: 'transactions',     label: 'Transactions',          icon: ArrowLeftRight },
      // { id: 'reconciliation',   label: 'Reconciliation',        icon: Scale, badge: 'dot' },
      {
        id: 'payouts', label: 'Payouts', icon: Banknote,
        // badge: 'dot'
      },
      { id: 'funding',          label: 'Funding',               icon: Coins },
      // { id: 'wallets',          label: 'Wallets',               icon: Wallet },
      { id: 'channels',         label: 'Channels',              icon: Store },
      { id: 'sales-setup',      label: 'Sales Setup',           icon: Tag },
    ],
  },
  {
    section: 'OPERATIONS',
    items: [
      { id: 'ticketing-inventory', label: 'Ticketing & Inventory', icon: Ticket },
      { id: 'products',         label: 'Products',              icon: Package },
      { id: 'access-control',   label: 'Access Control',        icon: ShieldCheck },
      // 'issues-approvals' (Issues & Approvals) removed from the sidebar — not fit for
      // its own top-level nav entry. The page + maker-checker flow remain reachable
      // programmatically (App route 'issues-approvals', e.g. from order/approval links).
      // { id: 'risk',             label: 'Risk & Compliance',     icon: ShieldAlert, badge: 'dot' },
    ],
  },
  {
    section: 'CUSTOMERS',
    items: [
      { id: 'people',           label: 'Users & Customers',     icon: Users },
      { id: 'accreditation',    label: 'Accreditation',         icon: BadgeCheck },
      { id: 'subscriptions',    label: 'Subscriptions',         icon: Bell },
    ],
  },
  {
    section: 'PLATFORM',
    items: [
      { id: 'reports',          label: 'Reports',               icon: BarChart3 },
      { id: 'support',          label: 'Support',               icon: Headset },
      { id: 'call-center',      label: 'Call Center',           icon: PhoneCall },
      { id: 'chat',             label: 'Chat',                  icon: MessageCircle },
      { id: 'design',           label: 'Design & Comms',        icon: Palette },
      { id: 'settings',         label: 'Platform Settings',     icon: Settings },
      { id: 'audit',            label: 'Audit Logs',            icon: ScrollText },
      { id: 'utilities',            label: 'Utilities',           icon: Wrench },
      // Backend Map / Reality Map: off the sidebar (and command palette, which reads
      // this same NAV) for now — bring back by uncommenting. Both routes still resolve
      // fine on a direct URL (/backend-capabilities, /functionality-reality) since
      // router.js's ROUTE_TABLE is untouched; this only hides the nav entry point.
      // { id: 'backend-capabilities', label: 'Backend Map',       icon: ServerCog },
      // { id: 'functionality-reality', label: 'Reality Map',       icon: Workflow },
      // `Plug`, not `Newspaper`: this is the ONE duplicated icon in the nav, and the page is a
      // connector — it mints a token and plugs Claude into the reporting engine. Release Notes
      // keeps Newspaper, which a changelog actually earns.
      { id: 'reports-mcp',      label: 'Reports MCP',           icon: Plug },
      { id: 'release-notes',    label: 'Release Notes',         icon: Newspaper },
    ],
  },
];

// Items hidden on the trimmed (Moments, non-full-access) nav — see accessGating.js.
// Funding/Channels/Products/Accreditation/Subscriptions + every Platform entry
// except Reports (Moments doesn't operate those modules).
const TRIMMED_HIDDEN_IDS = new Set([
  'funding', 'channels', 'products', 'accreditation', 'subscriptions',
  'support', 'call-center', 'chat', 'design', 'settings', 'audit',
  'split-payments',
  'utilities', 'backend-capabilities', 'functionality-reality', 'release-notes', 'reports-mcp',
]);

export const getVisibleNav = (trimmed) => {
  if (!trimmed) return NAV;
  return NAV
    .map((group) => ({ ...group, items: group.items.filter((it) => !TRIMMED_HIDDEN_IDS.has(it.id)) }))
    .filter((group) => group.items.length > 0);
};
